/** Misma clave que en la política de cookies (ekk_cookies_consent). */
export const COOKIE_CONSENT_STORAGE_KEY = "ekk_cookies_consent";

export const COOKIE_CONSENT_EVENT = "ekklesia:cookie-consent-updated";

export const OPEN_COOKIE_SETTINGS_EVENT = "ekklesia:open-cookie-settings";

function dispatchConsentUpdated() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT));
  }
}

/**
 * @returns {{ analytics: boolean, functional: boolean, answered: boolean }}
 */
export function readCookieConsent() {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (raw === null || raw === "") {
      return { analytics: false, functional: false, answered: false };
    }
    if (raw === "accepted") {
      return { analytics: true, functional: true, answered: true };
    }
    if (raw === "rejected") {
      return { analytics: false, functional: false, answered: true };
    }
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && parsed.v === 1) {
      return {
        analytics: Boolean(parsed.analytics),
        functional: Boolean(parsed.functional),
        answered: true,
      };
    }
  } catch {
    /* ignore */
  }
  return { analytics: false, functional: false, answered: false };
}

/**
 * @param {{ analytics: boolean, functional: boolean }} prefs
 */
export function saveCookieConsent(prefs) {
  try {
    const payload = JSON.stringify({
      v: 1,
      ts: Date.now(),
      analytics: Boolean(prefs.analytics),
      functional: Boolean(prefs.functional),
    });
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, payload);
  } catch {
    /* ignore */
  }
  dispatchConsentUpdated();
}

export function openCookieSettingsModal() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(OPEN_COOKIE_SETTINGS_EVENT));
  }
}
